import { useMemo, useState } from 'react';
import { IContact } from 'src/services/api/ServiceRequestDashboard/apiContracts';

export interface IUseContactBasicFiltersReturn {
  contacts: IContact[];
  basicSearchTerm: string;
  updateBasicSearchTerm: (value: string) => void;
  clearBasicSearchTerm: () => void;
  isEngaged: boolean;
}

const matchesBasicSearch = (contact: IContact, term: string): boolean => {
  const firstname: string = contact.firstname?.toLowerCase() || '';
  const lastname: string = contact.lastname?.toLowerCase() || '';
  const email: string = contact.email?.toLowerCase() || '';
  const phone: string = (contact.phone || '').replace(/\D/g, '');

  const fullName: string = `${firstname} ${lastname}`.trim();

  if (firstname.includes(term)) {
    return true;
  }

  if (lastname.includes(term)) {
    return true;
  }

  if (fullName.includes(term)) {
    return true;
  }

  if (email.includes(term)) {
    return true;
  }

  const phoneTerm: string = term.replace(/\D/g, '');

  if (phoneTerm.length > 0 && phone.includes(phoneTerm)) {
    return true;
  }

  return false;
};

export const useContactBasicFilters = (
  sourceContacts: IContact[]
): IUseContactBasicFiltersReturn => {
  const [basicSearchTerm, setBasicSearchTerm] = useState<string>('');

  const isEngaged: boolean = basicSearchTerm.trim().length > 0;

  const contacts: IContact[] = useMemo(() => {
    if (!isEngaged) {
      return sourceContacts;
    }

    const term: string = basicSearchTerm.toLowerCase().trim();

    return sourceContacts.filter((contact: IContact) =>
      matchesBasicSearch(contact, term)
    );
  }, [isEngaged, sourceContacts, basicSearchTerm]);

  const updateBasicSearchTerm = (value: string) => {
    setBasicSearchTerm(value);
  };

  const clearBasicSearchTerm = () => {
    setBasicSearchTerm('');
  };

  return {
    contacts,
    basicSearchTerm,
    updateBasicSearchTerm,
    clearBasicSearchTerm,
    isEngaged,
  };
};
